import { AxiosResponse } from "axios";
import API from "../api";
import { Notification } from "../models/notification";

import BaseService from "./_base.service";

const endpoint = "notification";

const NotificationsService = {
  ...BaseService<Notification>({ endpoint }),
  async countMy(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${endpoint}/my/count`, { params: options });
  },
  async getAllMy(options?: any): Promise<AxiosResponse<Notification[]>> {
    return await API.get(`/${endpoint}/my`, { params: options });
  },
  async realAllMy(): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${endpoint}/my/read/all`);
  },
};

export default NotificationsService;
